import { Router } from "express";
import { isRoute } from "./route";

export function registerRoutes(
  baseRouter: Router,
  routeTree: Record<string, any>,
  basePath: string = "",
  getHandler: (pathToRoute: string, route: string) => () => Promise<any>,
) {
  Object.entries(routeTree).forEach(([key, value]) => {
    if (isRoute(value)) {
      // This is a route endpoint - register it
      const fullPath = `${basePath}/${key}`;

      const handler = getHandler(basePath, key);
      if (!handler) {
        throw new Error(`No handler found for route: ${fullPath}`);
      }

      baseRouter[value.method](fullPath, handler);

      console.log(`Registered route: ${value.method.toUpperCase()} ${fullPath}`);
    } else if (typeof value === "object" && value !== null) {
      // This is a nested object - recurse with updated base path
      registerRoutes(baseRouter, value, `${basePath}/${key}`, getHandler);
    }
  });

  return baseRouter;
}
